<div class="scanner-wrapper" data-test="scan-qr-content">
    @if (scanNotification$ | async; as notification) {
        <priva-notification status="Warning" class="scan-notification" data-test="scan-qr-notification">
            {{ notification }}
        </priva-notification>
    }

    @if (cameraFound || scannerStarting) {
        <zxing-scanner
            [class.scanner--starting]="scannerStarting"
            (scanSuccess)="onCodeScanned($event)"
            (autostarted)="onScannerStarted()"
            (camerasFound)="onCamerasFound()"
            [formats]="supportedBarcodeFormats"
            data-test="qr-scanner"
        />
    } @else {
        <priva-notification status="Warning">
            {{ 'SETUP.STEP_2.ERROR.NO_CAMERA_FOUND' | translate }}
        </priva-notification>
    }

    @if (scannerStarting) {
        <priva-loader [hasFooter]="true">
            <priva-spinner />
            <div class="loader__footer" data-footer>
                {{ 'SETUP.STEP_2.TITLE.CAMERA_STARTING' | translate }}
            </div>
        </priva-loader>
    }
</div>
